module.exports = __webpack_public_path__ + "img/gnu_gallery7.9606e7c6.jpg";